import $ from 'jquery';
import variables from "./components/variables";

$.ajaxSetup({
    headers: {
        "X-CSRFToken": variables.csrfToken
    }
});

require('jquery-validation');

import("./components/layout").then(layout => layout.default());

if ($('#modal-delete').length) {
    import("./components/delete").then(modalDelete => modalDelete.default());
}
if ($('#form-application').length) {
    import("./pages/application").then(application => application.default());
}
if ($('#form-release').length) {
    import("./pages/release").then(release => release.default());
}
if ($('#form-user').length) {
    import("./pages/user").then(user => user.default());
}
if ($('#form-role').length) {
    import("./pages/role").then(role => role.default());
}


// loading misc scripts
require('./scripts/loader');
require('./scripts/validation');
require('./scripts/table-responsive');
require('./scripts/one-touch-submit');
require('./scripts/miscellaneous');

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register(variables.baseUrl + 'assets/src/javascripts/service-worker.js')
            .then((registration) => {
                console.log('ServiceWorker registered:', registration);
            })
            .catch((error) => {
                console.log('ServiceWorker registration failed:', error);
            });
    });
}

import '../sass/app.scss';
